import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { apiPost } from "../service/admin/apiService";
import { showSuccess, showError } from "../utils/toast";
import DateFilters from "../components/client/dateFilters";
import ExportToExceljs from "../utils/exportToExcel";
import ExportToExcelGen24Q from "../utils/exportToExcelGen24Q";
import ExportToExcelGen26Q from "../utils/exportToExcelGen26Q";
import ExportToExcelGen27Q from "../utils/exportToExcelGen27Q";
import Loader from "./loader";
import { useNavigate, useLocation } from "react-router-dom";
import { getMonthsForQuarters } from "../utils/client/misc";

const PrintReport = ({ reportType = "" }) => {
  const [clientList, setClientList] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [formFinancialYear, setFormFinancialYear] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [filteredMonths, setFilteredMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [showModal, setShowModal] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedFYearId, setSelectedFYearId] = useState(0);
  const [selectedClient, setSelectedClient] = useState("");
  const [employerData, setEmployerData] = useState([]);
  const [selectedForm, setSelectedForm] = useState("");
  const [deducteeData, setDeducteeData] = useState([]);
  const [challanData, setChallanData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [formName, setFormName] = useState("");
  const [salaryDetailData, setSalaryDetailData] = useState([]);
  const [repoType, setRepoType] = useState("");
  const [taxRgmType, setTaxRgmType] = useState("oldTxRgm");
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = location.pathname === "/print-gen-report";
  const isClient = location.pathname === "/print-emp-report";
  let tk = "";
  let clientInfo = "";

  if (isAdmin) {
    tk = localStorage.getItem("tk");
  } else if (isClient) {
    clientInfo = JSON.parse(localStorage.getItem("clientInfo"));
  }
  let ui = localStorage.getItem("ui");

  useEffect(() => {
    if (isAdmin) {
      getClientList();
    }
  }, [isAdmin]);

  useEffect(() => {
    if (selectedClient !== "") {
      getEmployer_DeducteeDetail();
    }
  }, [selectedClient]);

  useEffect(() => {
    if (deducteeData.length > 0) {
      get24QSalaryDetail();
    }
  }, [deducteeData]);

  useEffect(() => {
    if (selectedQuarter !== "") {
      const months = getMonthsForQuarters(selectedQuarter);
      setFilteredMonths(months);
    }
  }, [selectedQuarter]);

  useEffect(() => {
    if (filteredMonths.length > 0 && isAdmin) {
      get24QChallanDetail();
    } else if (filteredMonths.length > 0 && isClient) {
      getClientsEmpQtrData();
    }
  }, [filteredMonths]);

  useEffect(() => {
    if (challanData.length > 0) {
      get24QDeducteeDetail();
    }
  }, [challanData]);

  //ADMIN
  const getClientList = async () => {
    setShowLoader(true);
    const payload = {
      action: "userclientlinklist",
      to: tk,
      ui: ui,
    };

    if (tk && tk !== "") {
      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setShowLoader(false);
        } else if (response?.responsedetails) {
          console.log("clientlist", response?.responsedetails);
          const clist = response?.responsedetails?.filter((el) => el.li != 0);
          if (clist) {
            setClientList(clist);
            setShowLoader(false);
          }
        }
      } catch (err) {
        console.error("Error:", err);
        setShowLoader(false);
      }
    }
  };

  const get24QSalaryDetail = async () => {
    const payload = {
      action: "reportemptotals",
      to: tk,
      fi: selectedFYearId,
      clid: selectedClient,
    };
    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setShowLoader(false);
      } else if (
        Array.isArray(response?.responsedetails) &&
        response.responsedetails.length > 0
      ) {
        console.log("Salary Detail", response?.responsedetails);
        setSalaryDetailData(response?.responsedetails);
      }
    } catch (err) {
      console.error("Error:", err);
      setShowLoader(false);
    }
  };

  const get24QChallanDetail = async () => {
    setShowLoader(true);
    setChallanData([]);
    const payload = {
      action: "formlist",
      clid: selectedClient,
      fi: selectedFYearId,
      mn: filteredMonths[0],
      mn2: filteredMonths[1],
      mn3: filteredMonths[2],
      to: tk,
      ty: "challandetails",
      fona: selectedForm,
      rpt: "yes",
    };
    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setShowLoader(false);
      } else if (
        Array.isArray(response?.responsedetails) &&
        response.responsedetails.length > 0
      ) {
        console.log("challanData", response?.responsedetails);
        setChallanData(response?.responsedetails);
      } else {
        console.log("challanData", response?.responsedetails);
        showError(
          "No challan data found for selected financial year and month"
        );
        get24QDeducteeDetail();
      }
    } catch (err) {
      console.error("Error:", err);
      setShowLoader(false);
    }
  };

  const getEmployer_DeducteeDetail = async () => {
    setShowLoader(true);
    setEmployerData([]);
    const payload = {
      action: "clientlist",
      ci: selectedClient,
      to: tk,
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setShowLoader(false);
      } else if (
        Array.isArray(response?.responsedetails) &&
        response.responsedetails.length > 0
      ) {
        console.log("client info", response?.responsedetails);
        setEmployerData(response?.responsedetails);
        setShowLoader(false);
      }
    } catch (err) {
      console.error("Error:", err);
      setShowLoader(false);
    }
  };

  const get24QDeducteeDetail = async () => {
    setShowLoader(true);
    setDeducteeData([]);
    const payload = {
      action: "formlist",
      clid: selectedClient,
      fi: selectedFYearId,
      mn: filteredMonths[0],
      mn2: filteredMonths[1],
      mn3: filteredMonths[2],
      to: tk,
      ty: selectedForm,
      rpt: "yes",
    };
    console.log("payload", payload);

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);

      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setShowLoader(false);
      } else if (
        Array.isArray(response?.responsedetails) &&
        response.responsedetails.length > 0
      ) {
        console.log("DeducteeDetail", response?.responsedetails);
        setDeducteeData(response?.responsedetails);
        setShowLoader(false);
      } else {
        console.log("DeducteeDetail", response?.responsedetails);
        showError("No data found for selected financial year and month");
        setShowLoader(false);
      }
    } catch (err) {
      console.error("Error:", err);
      setShowLoader(false);
    }
  };

  //CLIENT

  const getClientsEmpQtrData = async () => {
    let clientIds = [];
    let childIds = [];
    let allClientData = [];

    clientIds.push({ id: clientInfo.client?.id });

    console.log("sssdsdsd0", clientInfo?.client?.pids.length);
    console.log("repo", repoType);
    if (clientInfo?.client?.pids.length > 0 && repoType === "group") {
      childIds = clientInfo?.client?.pids;
    }
    const cids = [...clientIds, ...childIds];
    // console.log("childIds", cids);

    // for (const client of cids) {
    //   console.log("clientids111", client.id);
    // }

    if (clientInfo?.tk && clientInfo?.tk !== "") {
      setShowLoader(true);

      try {
        for (const client of cids) {
          const payload = {
            action: "reportemptax",
            to: clientInfo?.tk,
            fi: selectedFYearId,
            mn: filteredMonths[0],
            mn2: filteredMonths[1],
            mn3: filteredMonths[2],
            clid: client.id, // clientInfo.client?.id,
          };
          console.log("payloadEmpTax", payload);
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload
          );
          if (Number(response?.errordetails?.errorcode) > 0) {
            //showError(response?.errordetails?.error);
            //setShowLoader(false);
            showError(
              `Client ${clientInfo?.client?.cn}: ${response?.errordetails?.error}`
            );
          } else if (response?.responsedetails) {
            console.log("empData", response?.responsedetails);
            // setReportData(response?.responsedetails);
            // setFileName(`Employee Data For (${selectedQuarter})`);
            // setFormName("employeeData");
            // setShowLoader(false);
            allClientData.push({
              data: response.responsedetails,
            });
          }
        }
        console.log("report", allClientData);
        setReportData(allClientData);
        setFileName(`${clientInfo?.client?.ta} (${selectedQuarter})`);
        setFormName("employeeData");
        setShowLoader(false);
      } catch (err) {
        console.error("Error:", err);
        showError("Error fetching data");
      }
    }
  };

  return (
    <>
      <Modal
        show={showModal}
        centered
        backdrop="static"
        onHide={() => {
          setShowModal(false);
          navigate("/review-data");
        }}
      >
        <Modal.Header className="custom-header flex-column align-items-start w-100">
          <div className="d-flex justify-content-between w-100 align-items-center">
            <Modal.Title>{reportType || "Print Report"}</Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* New Dropdowns for Client and Form */}
          {isAdmin ? (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Client Name</Form.Label>
                <Form.Select
                  value={selectedClient}
                  onChange={(e) => [
                    setSelectedClient(e.target.value),
                    setSelectedYear(""),
                    setSelectedMonth(""),
                    setSelectedQuarter(""),
                    setSelectedForm(""),
                    setDeducteeData([]),
                    setChallanData([]),
                    setEmployerData([]),
                  ]}
                >
                  <option value="">Select Client</option>
                  {clientList.map((client) => (
                    <option key={client.ci} value={client.ci}>
                      {`${client.cn}`}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Form Name</Form.Label>
                <Form.Select
                  value={selectedForm}
                  onChange={(e) => [
                    setSelectedForm(e.target.value),
                    setSelectedQuarter(""),
                    setSelectedYear(""),
                  ]}
                >
                  <option value="">Select Form</option>
                  {/* Replace below with dynamic form options if needed */}
                  <option value="form24q">Form 24Q</option>
                  <option value="form26q">Form 26Q</option>
                  <option value="form27eq">Form 27EQ</option>
                </Form.Select>
              </Form.Group>
              {/* <Form className="mb-2">
                <div className="d-flex align-items-center gap-3">
                  <Form.Check
                    type="radio"
                    label="Old Tax Regime"
                    name="oldTxRgm"
                    value="oldTxRgm"
                    checked={taxRgmType === "oldTxRgm"}
                    onChange={(e) => [setTaxRgmType(e.target.value)]}
                  />
                  <Form.Check
                    type="radio"
                    label="New Tax Regime"
                    name="newTxRgm"
                    value="newTxRgm"
                    checked={taxRgmType === "newTxRgm"}
                    onChange={(e) => [setTaxRgmType(e.target.value)]}
                  />
                </div>
              </Form> */}
            </>
          ) : null}

          {isClient && clientInfo?.client?.igc === 1 ? (
            <Form>
              <div className="d-flex align-items-center gap-3">
                <Form.Check
                  type="radio"
                  label="Group Report"
                  name="reportType"
                  value="group"
                  checked={repoType === "group"}
                  onChange={(e) => [
                    setRepoType(e.target.value),
                    setSelectedYear(""),
                    setSelectedMonth(""),
                    setSelectedQuarter(""),
                    setReportData([]),
                  ]}
                />
                <Form.Check
                  type="radio"
                  label="Normal Report"
                  name="reportType"
                  value="normal"
                  checked={repoType === "normal"}
                  onChange={(e) => [
                    setRepoType(e.target.value),
                    setSelectedYear(""),
                    setSelectedMonth(""),
                    setSelectedQuarter(""),
                  ]}
                />
              </div>
            </Form>
          ) : null}

          {/* Existing Date Filters */}
          <DateFilters
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedQuarter={selectedQuarter}
            setSelectedQuarter={setSelectedQuarter}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            getFormInfo={() => {}}
            setSelectedFYearId={setSelectedFYearId}
            setFormInfo={() => {}}
            setFormFinancialYear={setFormFinancialYear}
            showMonth={false}
          />
        </Modal.Body>

        <Modal.Footer>
          {isClient ? (
            <ExportToExceljs
              data={reportData}
              fileName={fileName}
              formName={formName}
              clientName={""}
              clientTan={""}
              financialYear={selectedYear}
              month={`${filteredMonths[0]}, ${filteredMonths[1]}, ${filteredMonths[2]}`}
              selectedQuarter={selectedQuarter}
              buttonType="GenerateReport"
            />
          ) : null}
          {isAdmin ? (
            selectedForm === "form24q" ? (
              <ExportToExcelGen24Q
                employerData={employerData}
                challanData={challanData}
                deducteeData={deducteeData}
                salaryDetailData={salaryDetailData}
                fileName={`${employerData[0].fn}_${employerData[0].ta}_Form24Q_${selectedYear}_${selectedMonth}`}
                formName={selectedForm}
                clientName=""
                clientTan=""
                financialYear={selectedYear}
                month={selectedMonth}
                selectedQuarter={selectedQuarter}
                buttonType="GenerateReport"
                //txRgmType={taxRgmType}
              />
            ) : selectedForm === "form26q" ? (
              <ExportToExcelGen26Q
                employerData={employerData}
                challanData={challanData}
                deducteeData={deducteeData}
                salaryDetailData={[]}
                fileName={`${employerData[0].fn}_${employerData[0].ta}_Form26Q_${selectedYear}_${selectedMonth}`}
                formName={selectedForm}
                clientName=""
                clientTan=""
                financialYear={selectedYear}
                month={selectedMonth}
                selectedQuarter={selectedQuarter}
                buttonType="GenerateReport"
              />
            ) : selectedForm === "form27eq" ? (
              <ExportToExcelGen27Q
                employerData={employerData}
                challanData={challanData}
                deducteeData={deducteeData}
                salaryDetailData={[]}
                fileName={`${employerData[0].fn}_${employerData[0].ta}_Form27Q_${selectedYear}_${selectedMonth}`}
                formName={selectedForm}
                clientName=""
                clientTan=""
                financialYear={selectedYear}
                month={selectedMonth}
                selectedQuarter={selectedQuarter}
                buttonType="GenerateReport"
              />
            ) : null
          ) : null}

          <Button
            className="btn-primary-submit-to-ca"
            onClick={() => {
              setShowModal(false);
              navigate(isAdmin ? "/review-data" : "/client-form-24Q"); //: "/client-dashboard"
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {showLoader ? <Loader show={showLoader} /> : null}
    </>
  );
};

export default PrintReport;
